import React, { useContext } from 'react';
import styles from './styles.module.css';
import { fsfLogo } from 'assets/newIcons';
import MobileContext from 'context/MobileContext';

const Header = () => {
  const isMobile = useContext(MobileContext);

  return (
    <div className={styles.container}>
      <div className={`${styles.headerContainer} ${isMobile ? styles.mob : null}`}>
        <img
          src={fsfLogo}
          alt="logo"
          className={`${styles.logo} ${isMobile ? styles.mob : null}`}
        />
      </div>
    </div>
  );
};

export default Header;
